import { render, staticRenderFns } from "./SmsGiphyContainer.vue?vue&type=template&id=35c61a23&scoped=true&"
import script from "./SmsGiphyContainer.vue?vue&type=script&lang=js&"
export * from "./SmsGiphyContainer.vue?vue&type=script&lang=js&"
import style0 from "./SmsGiphyContainer.vue?vue&type=style&index=0&id=35c61a23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c61a23",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsConversation%2FSmsGiphyComponents%2FSmsGiphyContainer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports